import { Vector3 } from 'three';

/**
 * Get the axis of the normal vector with the highest magnitude.
 *
 * @param normal
 * @returns The axis of the normal vector with the highest magnitude.
 */
export const getNormalAxis = (normal: Vector3) => {
  const axis =
    Math.abs(normal.x) > Math.abs(normal.y)
      ? Math.abs(normal.x) > Math.abs(normal.z)
        ? 'x'
        : 'z'
      : Math.abs(normal.y) > Math.abs(normal.z)
      ? 'y'
      : 'z';

  return axis;
};
